import { apiFetch, readJsonResponse } from "@/lib/api"
import { isIntercomTokenResponse } from "@/lib/intercom/guards"
import type { IntercomBootUser } from "@/lib/intercom/types"

export async function getIntercomBootUser(signal?: AbortSignal) {
  const response = await apiFetch("/api/auth/intercom-token/", { signal })

  if (!response.ok) {
    return null
  }

  const data = await readJsonResponse(response)
  if (!isIntercomTokenResponse(data)) {
    return null
  }

  return {
    intercom_user_jwt: data.intercom_jwt,
    expires_at: data.expires_at,
    user_id: data.user_id,
    email: data.attributes.email,
    name: data.attributes.name,
    created_at: data.attributes.created_at,
    company: data.attributes.company,
  } satisfies IntercomBootUser
}
